export const ledgerPaymentsTranslations = {
    de: {
        advanceReassign: 'Anzahlungszuordnung korrigieren',
        advanceReassignHint: 'Verschieben Sie die gesamte ursprüngliche Zuordnung auf eine andere Anzahlungsanforderung desselben Geschäftspartners und derselben Währung. Die tatsächliche Zahlung bleibt unverändert. Bereits angerechnete oder erstattete Anteile müssen zuerst geklärt werden.',
        advanceReassignReady: 'Die alte Zuordnung wird gemeinsam mit der geprüften Ersatzzuordnung korrigiert. Es entsteht keine weitere Zahlung.',
        advanceReassignConfirm: 'Umzuordnung bestätigen',
        advanceReassignSaved: 'Die Anzahlungszuordnung wurde korrigiert.',
        importAdvanceOriginalNotes: 'Originalhinweise zu Anzahlungen',
        importAdvanceNotesHint: 'Diese Texte stammen unverändert aus dem Lieferantenoriginal. Die folgende Bewertung ist eine gesonderte menschliche Entscheidung.',
        importAdvanceNotesReview: 'Originalhinweise prüfen',
        importAdvanceNotesDisposition: 'Bewertung der Originalhinweise',
        importAdvanceNotesChoose: 'Bewertung ausdrücklich auswählen',
        importAdvanceNotesNoSpecific: 'Keine konkret bestimmbaren Anzahlungsabzüge im Text erkennbar',
        importAdvanceNotesMatchedChoices: 'Originaltext mit den genau ausgewählten tatsächlichen Zahlungen abgeglichen',
        importAdvanceNotesExplanation: 'Begründung der Hinweisprüfung',
        importAdvanceNotesManual: 'Originalhinweise manuell geprüft',
        importAdvanceNotesInvalid: 'Wähle eine Bewertung und begründe die Prüfung mit 10 bis 1000 Zeichen.',
        importAdvanceNotesUnavailable: 'Die Originalhinweise können derzeit nicht zuverlässig geprüft werden. Lade den aktuellen Stand erneut.',
        ADVANCE_REFUND: 'Anzahlungsrückzahlung zugeordnet',
        ADVANCE_REFUND_REVERSAL: 'Rückzahlungszuordnung korrigiert',
        advanceRefundCorrection: 'Rückzahlungszuordnung korrigieren',
        advanceRefundCorrectionHint: 'Die tatsächliche Gegenzahlung bleibt erfasst. Nur diese Zuordnung und ihre Steuerwirkung werden aufgehoben; andere Zuordnungen bleiben erhalten.',
        advanceRefundOriginal: 'Ursprüngliche Rückzahlung',
        advanceRefundCorrectionConfirm: 'Zuordnungskorrektur bestätigen',
        advanceRefundCorrectionSaved: 'Die Rückzahlungszuordnung wurde korrigiert.',
        advanceRefundCorrectionChanged: 'Die Zahlungsdaten haben sich geändert. Prüfen Sie die aktuellen Angaben und bestätigen Sie erneut. Ihre Eingaben bleiben erhalten.',
        advanceRefundCorrectionRecheck: 'Aktuelle Angaben erneut prüfen',
        advanceRefund: 'Tatsächliche Anzahlungsrückzahlung prüfen',
        advanceRefundHint: 'Wählen Sie die ursprünglich bezahlte Anzahlung und eine erfasste Rückzahlung in Gegenrichtung. Prüfen Sie vor der Bestätigung die genauen Steuerbeträge. Es wird keine Zahlung erzeugt.',
        advanceRefundSource: 'Ursprünglich bezahlte Anzahlungsanforderung',
        advanceRefundCounterpayment: 'Tatsächliche Gegenzahlung',
        advanceRefundNoSources: 'Für diese Zahlung wurde keine rückzahlbare bezahlte Anzahlung gefunden.',
        advanceRefundNoCounterpayment: 'Es ist keine passende freie Gegenzahlung vorhanden. Erfassen Sie zuerst die tatsächliche Rückzahlung und kehren Sie dann zu dieser Prüfung zurück.',
        advanceRefundRecord: 'Tatsächliche Rückzahlung erfassen',
        advanceRefundAvailable: 'Rückzahlbar brutto',
        advanceRefundReview: 'Rückzahlung prüfen',
        advanceRefundConfirm: 'Geprüfte Rückzahlung bestätigen',
        advanceRefundSaved: 'Die Anzahlungsrückzahlung wurde erfasst.',
        advanceRefundMore: 'Weitere ursprüngliche Anzahlungen anzeigen',
        advanceRefundChanged: 'Anzahlung oder Zahlungen wurden geändert. Prüfen Sie die aktuellen Quelldaten und die Rückzahlung erneut; Ihre Eingaben bleiben erhalten.',
        advanceRefundChoice: 'Ursprüngliche Anzahlung auswählen',
        advanceRefundCounterChoice: 'Gegenzahlung auswählen',
        advanceRefundPaymentFacts: '{{date}} · {{reference}} · {{amount}}',
        advanceRefundSourceFacts: '{{number}} · Bezahlt am {{date}}',
        importAdvanceOriginalDeductions: 'Anzahlungsabzüge laut Original',
        importAdvanceDeductionRequired: 'Die im Original genannten Anzahlungen müssen mit den ausgewählten Zahlungen abgeglichen werden.',
        importAdvanceDeductionMatched: 'Die ausgewählten Anzahlungen stimmen mit den Abzügen des Originals überein.',
        importAdvanceDeductionConflict: 'Die Anzahlungsabzüge des Originals stimmen nicht mit den Zahlungsnachweisen überein. Prüfe Belegnummern, Termine und Beträge.',
        importAdvanceTitle: 'Anzahlungen der importierten Schlussrechnung',
        importAdvanceHint: 'Ordne den Anzahlungsbetrag des Lieferanten gezielt bereits geleisteten Zahlungen und Steuergruppen zu. Die Originalrechnung bleibt unverändert; es entsteht keine neue Zahlung.',
        importAdvanceOriginal: 'Brutto laut Original',
        importAdvancePrepaid: 'Anzahlungen laut Original',
        importAdvanceDue: 'Restbetrag laut Original',
        importAdvanceReceipt: '{{number}} · Zahlung vom {{date}}',
        importAdvanceAvailable: 'Verfügbarer Bruttobetrag',
        importAdvanceEmpty: 'Keine passende bereits geleistete Anzahlung verfügbar.',
        importAdvanceChanged: 'Die Rechnung oder ihre Anzahlungen haben sich geändert. Lade den Stand neu und prüfe die Zuordnung erneut.',
        importAdvanceSaved: 'Die geprüfte Anzahlungszuordnung wurde gespeichert.',
        importAdvanceConfirmed: 'Gespeicherte Anzahlungszuordnung',
        importAdvanceReadOnly: 'Zum Ändern dieser Zuordnung sind Zahlungs- und Einkaufsbearbeitungsrechte erforderlich.',
        importAdvanceMore: 'Weitere geleistete Anzahlungen anzeigen',
        advanceCancelled: 'Anzahlungsanforderung storniert',
        advanceRequested: 'Angeforderter Betrag',
        advanceReviewed: 'Bei der Stornierung geprüft',
        advanceCurrent: 'Aktueller Stand',
        advanceDispositionChanged: 'Die Geldverwendung hat sich seit der Stornierung geändert.',
        advanceDispositionUnchanged: 'Die Geldverwendung ist seit der Stornierung unverändert.',
        advanceCancelState: 'Stornierung der Anzahlungsanforderung',
        advanceCancel: 'Anzahlungsanforderung stornieren',
        advanceCancelDate: 'Wirksamkeitsdatum',
        advanceCancelReason: 'Begründung der Stornierung',
        advanceCancelReview: 'Stornierung prüfen',
        advanceCancelSubmit: 'Anforderung stornieren',
        advanceRetained: 'Verbleibende Anzahlung',
        advanceCancelChanged: 'Die zugrunde liegenden Zahlungen haben sich geändert. Prüfe erneut.',
        advanceCancelHelp: 'Bereits erhaltene oder geleistete Beträge bleiben bis zur tatsächlichen Rückzahlung oder zulässigen Zuordnung erhalten.',
        advanceDeductible: 'Abziehbare Vorsteuer',
        advanceChoices: 'Anzahlungen zuordnen',
        advanceChoiceHint: 'Wähle eine Anzahlungsanforderung und prüfe die Beträge je Steuersatz.',
        advanceCurrency: 'Währung der Anzahlungsanforderung',
        advanceMoneyHint: 'Belegbetrag, tatsächlicher Zahlungsanteil und Steuerkurs werden getrennt geprüft.',
        advanceRefundActualMoney: 'Tatsächlich zurückgezahlter Betrag ({{currency}})',
        advanceChooseRate: 'Steuerkurs auswählen',
        noAdvances: 'Keine offene Anzahlungsanforderung gefunden.',
        firstPage: 'Erste Seite',
        advanceRateAmount: 'Betrag bei {{rate}} %',
        advanceReason: 'Begründung der Zuordnung',
        advanceSelected: 'Ausgewählter Betrag',
        advanceReview: 'Zuordnung prüfen',
        advanceGross: 'Brutto',
        advanceTax: 'Umsatzsteuer',
        advanceAdd: 'Geprüfte Zuordnung übernehmen',
        WRITE_OFF_RECOVERY: 'Ausgebuchte Forderung wiederhergestellt',
        WRITE_OFF_RECOVERY_REVERSAL: 'Wiederherstellung der Forderung korrigiert',
        WRITE_OFF_CREDIT_CORRECTION: 'Forderungsausfall mit Rechnungskorrektur verrechnet',
        CREDIT_DISCOUNT_CORRECTION: 'Skonto mit Rechnungskorrektur verrechnet',
        offsetReview: 'Auswahl neu prüfen',
        offsetReviewed: 'Restbeträge und Versionen aktualisiert. Prüfe Beträge und Datum vor dem Speichern.',
        offset: 'Guthaben verrechnen',
        offsetCounterpart: 'Gegenläufige Zahlung desselben Partners',
        offsetAmount: 'Betrag dieser Zahlung',
        offsetOtherAmount: 'Betrag der Gegenbuchung',
        offsetSave: 'Verrechnung speichern',
        offsetHint: 'Verknüpft bereits erfasste Geldeingänge und Geldausgänge. Es entsteht keine weitere Zahlung. Bei verschiedenen Währungen beide Beträge und die Umrechnungsquelle ausdrücklich prüfen.',
        offsetEmpty: 'Keine passende Zahlung mit verfügbarem Restbetrag gefunden.',
        reverseOffset: 'Verrechnung aufheben',
        offsetReverseHint: 'Hebt nur die Verrechnung auf. Die tatsächlichen Zahlungen und ihre ursprünglichen Nachweise bleiben erhalten.',
        offsetDefaultReason: 'Erstattung mit bestehendem Partnerguthaben verrechnet',
        PAYMENT_OFFSET: 'Guthabenverrechnung',
        PAYMENT_OFFSET_REVERSAL: 'Guthabenverrechnung aufgehoben',
        baseCurrencyRate: 'Basiswährung',
        selectAccount: 'Geldkonto auswählen',
        saveAllocation: 'Zuordnung speichern',
        allocationSaved: 'Zuordnung gespeichert.',
        reverseAllocation: 'Zuordnung aufheben',
        reversePayment: 'Fehlerhafte Erfassung stornieren',
        reverseHint: 'Eine tatsächliche Rückzahlung wird als neue Zahlung in Gegenrichtung erfasst. Dieses Storno korrigiert eine fehlerhafte Erfassung mit nachvollziehbarer Begründung.',
        reason: 'Begründung',
        history: 'Änderungsverlauf',
        ALLOCATION: 'Belegausgleich',
        ALLOCATION_REVERSAL: 'Ausgleich aufgehoben',
        previous: 'Zurück',
        next: 'Weiter',
        title: 'Zahlungen',
        subtitle: 'Tatsächliche Geldeingänge und Geldausgänge mit Belegzuordnung.',
        new: 'Zahlung erfassen',
        save: 'Ausgeführte Zahlung speichern',
        party: 'Partnerkonto',
        CUSTOMER: 'Kunde',
        VENDOR: 'Lieferant',
        partner: 'Kunde / Lieferant',
        direction: 'Zahlungsrichtung',
        CREDIT: 'Zahlungseingang',
        DEBIT: 'Zahlungsausgang',
        amount: 'Zahlungsbetrag',
        bookingDate: 'Zahlungsdatum',
        valueDate: 'Wertstellungsdatum',
        account: 'Geldkonto',
        currency: 'Währung',
        reference: 'Verwendungszweck / Herkunftsnachweis',
        fee: 'Gebühren in Zahlungswährung',
        advanced: 'Weitere Angaben',
        rate: 'Kurs zur Buchhaltungswährung',
        rateSource: 'Kursquelle',
        rateDate: 'Kursdatum',
        allocations: 'Belege zuordnen',
        selectInvoice: 'Beleg {{number}} auswählen',
        invoiceAmount: 'Zahlbetrag in Belegwährung',
        moneyAmount: 'Ausgleichsbetrag in Zahlungswährung',
        discount: 'Skonto in Belegwährung',
        effectiveDate: 'Zuordnung gültig am',
        noOpen: 'Keine offenen Belege für diese Auswahl.',
        unallocatedHint: 'Ohne Belegzuordnung bleibt die Zahlung als Partnerguthaben beziehungsweise ungeklärter Betrag erhalten.',
        actualHint: 'Erfasse hier bereits ausgeführte Zahlungen. Die Erfassung ist kein Zahlungsauftrag an die Bank.',
        saved: 'Zahlung erfasst.',
        status: 'Status',
        ACTIVE: 'Erfasst',
        REVERSED: 'Korrigiert',
        all: 'Alle',
        source: 'Herkunft',
        MANUAL: 'Manuell',
        BANK_IMPORT: 'Bankimport',
        remaining: 'Noch nicht zugeordnet',
        details: 'Zahlungsdetails',
        journal: 'Journalbuchung',
        bankEvidence: 'Banknachweis',
        invoice: 'Beleg',
        allocated: 'Zugeordnet',
        paymentTotal: 'Ausgleichsbetrag einschließlich Gebühren',
        setupRequired: 'Zuerst den Buchhaltungsstart und die Geldkonten einrichten.',
        partnersEmpty: 'Kein passender Kunde oder Lieferant.',
        search: 'Zahlungen durchsuchen',
        recorded: 'Erfasst am',
        partnerCredit: 'Partnerguthaben',
        invoiceCurrency: 'Belegwährung',
        addAllocation: 'Beleg hinzufügen',
        removeAllocation: 'Zuordnung entfernen',
        referenceHint: 'Zum Beispiel Kontoauszug, Kassenbeleg oder nachvollziehbare Zahlungsreferenz.',
        allocationHint: 'Gruppenzahlungen verteilst du auf mehrere Belege. Bei abweichenden Währungen trägst du beide Beträge und die Kursquelle ausdrücklich ein.',
        empty: 'Keine Zahlungen für diese Auswahl.',
        openItems: 'Offene Kunden- und Lieferantenposten',
        asOf: 'Stichtag',
        dueDate: 'Fälligkeit',
        gross: 'Ursprünglicher Betrag',
        open: 'Offener Betrag',
        OPEN: 'Offen',
        OVERDUE: 'Überfällig',
        CREDIT_BALANCE: 'Guthaben',
        SETTLED: 'Ausgeglichen',
        homeOpen: 'Offen in Buchhaltungswährung',
        historyHint: 'Belegbuchungen, Zahlungen und Korrekturen wirken ab ihrem jeweiligen fachlichen Datum. Spätere Zahlungen ändern frühere Stichtage nicht.',
        unassigned: 'Ohne Beleg',
        bankPostings: 'Bankbuchungen',
    },
    en: {
        advanceReassign: 'Correct advance allocation',
        advanceReassignHint: 'Move the whole original allocation to another advance request for the same partner and currency. Actual cash remains unchanged. Resolve already applied or refunded portions first.',
        advanceReassignReady: 'The original allocation and reviewed replacement will be corrected together. No additional payment is created.',
        advanceReassignConfirm: 'Confirm reassignment',
        advanceReassignSaved: 'The advance allocation was corrected.',
        importAdvanceOriginalNotes: 'Original advance notes',
        importAdvanceNotesHint: 'These texts are unchanged from the supplier original. The interpretation below is a separate human decision.',
        importAdvanceNotesReview: 'Review original notes',
        importAdvanceNotesDisposition: 'Interpretation of original notes',
        importAdvanceNotesChoose: 'Explicitly choose an interpretation',
        importAdvanceNotesNoSpecific: 'No identifiable specific advance deductions in the text',
        importAdvanceNotesMatchedChoices: 'Original text compared with the exact selected actual payments',
        importAdvanceNotesExplanation: 'Explanation of note review',
        importAdvanceNotesManual: 'Original notes manually reviewed',
        importAdvanceNotesInvalid: 'Choose an interpretation and explain the review in 10 to 1000 characters.',
        importAdvanceNotesUnavailable: 'The original notes cannot currently be reviewed reliably. Reload the current information.',
        ADVANCE_REFUND: 'Advance refund allocated',
        ADVANCE_REFUND_REVERSAL: 'Refund allocation corrected',
        advanceRefundCorrection: 'Correct refund allocation',
        advanceRefundCorrectionHint: 'The actual counter-payment stays recorded. Only this allocation and its tax effect are reversed; other allocations are preserved.',
        advanceRefundOriginal: 'Original refund',
        advanceRefundCorrectionConfirm: 'Confirm allocation correction',
        advanceRefundCorrectionSaved: 'The refund allocation was corrected.',
        advanceRefundCorrectionChanged: 'Payment facts have changed. Check the current details and confirm again. Your input is retained.',
        advanceRefundCorrectionRecheck: 'Review current details again',
        advanceRefund: 'Review actual advance refund',
        advanceRefundHint: 'Select the originally paid advance and a recorded repayment in the opposite direction. Review the exact tax amounts before confirming. This does not create a payment.',
        advanceRefundSource: 'Originally paid advance request',
        advanceRefundCounterpayment: 'Actual counter-payment',
        advanceRefundNoSources: 'No refundable paid advance was found for this payment.',
        advanceRefundNoCounterpayment: 'No matching unallocated counter-payment is available. Record the actual repayment first, then return to this review.',
        advanceRefundRecord: 'Record actual repayment',
        advanceRefundAvailable: 'Refundable gross',
        advanceRefundReview: 'Review refund',
        advanceRefundConfirm: 'Confirm reviewed refund',
        advanceRefundSaved: 'The advance refund was recorded.',
        advanceRefundMore: 'Show more original advances',
        advanceRefundChanged: 'The advance or payments changed. Review current source facts and the repayment again; your entries are retained.',
        advanceRefundChoice: 'Select original advance',
        advanceRefundCounterChoice: 'Select counter-payment',
        advanceRefundPaymentFacts: '{{date}} · {{reference}} · {{amount}}',
        advanceRefundSourceFacts: '{{number}} · Paid on {{date}}',
        importAdvanceOriginalDeductions: 'Advance deductions in the original',
        importAdvanceDeductionRequired: 'The advances listed in the original must be compared with the selected payments.',
        importAdvanceDeductionMatched: 'The selected advances match the deductions in the original.',
        importAdvanceDeductionConflict: 'Original advance deductions do not match the payment evidence. Review document numbers, dates and amounts.',
        importAdvanceTitle: 'Advances on the imported final invoice',
        importAdvanceHint: 'Match the supplier’s prepaid amount to specific actual payments and tax buckets. The original invoice remains unchanged and no new payment is created.',
        importAdvanceOriginal: 'Original gross total',
        importAdvancePrepaid: 'Original prepaid amount',
        importAdvanceDue: 'Original amount due',
        importAdvanceReceipt: '{{number}} · Paid on {{date}}',
        importAdvanceAvailable: 'Available gross amount',
        importAdvanceEmpty: 'No matching paid advance is available.',
        importAdvanceChanged: 'The invoice or its advances changed. Reload the current information and review the allocation again.',
        importAdvanceSaved: 'The reviewed advance allocation was saved.',
        importAdvanceConfirmed: 'Saved advance allocation',
        importAdvanceReadOnly: 'Payment and purchase editing permissions are required to change this allocation.',
        importAdvanceMore: 'Show more paid advances',
        advanceCancelled: 'Advance request cancelled',
        advanceRequested: 'Requested amount',
        advanceReviewed: 'Reviewed at cancellation',
        advanceCurrent: 'Current position',
        advanceDispositionChanged: 'The use of funds has changed since cancellation.',
        advanceDispositionUnchanged: 'The use of funds is unchanged since cancellation.',
        advanceCancelState: 'Advance request cancellation',
        advanceCancel: 'Cancel advance request',
        advanceCancelDate: 'Effective date',
        advanceCancelReason: 'Reason for cancellation',
        advanceCancelReview: 'Review cancellation',
        advanceCancelSubmit: 'Cancel request',
        advanceRetained: 'Retained advance',
        advanceCancelChanged: 'The underlying payments changed. Review again.',
        advanceCancelHelp: 'Money already received or paid remains until an actual refund or permitted reassignment.',
        advanceDeductible: 'Deductible input VAT',
        advanceChoices: 'Allocate advances',
        advanceChoiceHint: 'Choose an advance request and review the amount for each tax rate.',
        advanceCurrency: 'Advance request currency',
        advanceMoneyHint: 'The invoice amount, actual payment share and statutory VAT quote are reviewed separately.',
        advanceRefundActualMoney: 'Actual refund amount ({{currency}})',
        advanceChooseRate: 'Choose statutory quote',
        noAdvances: 'No open advance requests found.',
        firstPage: 'First page',
        advanceRateAmount: 'Amount at {{rate}}%',
        advanceReason: 'Reason for allocation',
        advanceSelected: 'Selected amount',
        advanceReview: 'Review allocation',
        advanceGross: 'Gross',
        advanceTax: 'VAT',
        advanceAdd: 'Add reviewed allocation',
        WRITE_OFF_RECOVERY: 'Written-off receivable restored',
        WRITE_OFF_RECOVERY_REVERSAL: 'Receivable restoration corrected',
        WRITE_OFF_CREDIT_CORRECTION: 'Receivable loss offset against invoice correction',
        CREDIT_DISCOUNT_CORRECTION: 'Cash discount offset against invoice correction',
        offsetReview: 'Review selection again',
        offsetReviewed: 'Balances and versions updated. Review amounts and date before saving.',
        offset: 'Set off credit',
        offsetCounterpart: 'Opposite payment of the same partner',
        offsetAmount: 'Amount of this payment',
        offsetOtherAmount: 'Counterpart amount',
        offsetSave: 'Save setoff',
        offsetHint: 'Links previously registered incoming and outgoing cash. No additional payment is created. For different currencies, explicitly review both amounts and their conversion source.',
        offsetEmpty: 'No matching payment with a remaining balance found.',
        reverseOffset: 'Reverse setoff',
        offsetReverseHint: 'Reverses only the setoff. Actual payments and their original evidence remain intact.',
        offsetDefaultReason: 'Refund set off against existing partner credit',
        PAYMENT_OFFSET: 'Credit setoff',
        PAYMENT_OFFSET_REVERSAL: 'Credit setoff reversed',
        baseCurrencyRate: 'Base currency',
        selectAccount: 'Select money account',
        saveAllocation: 'Save allocation',
        allocationSaved: 'Allocation saved.',
        reverseAllocation: 'Undo allocation',
        reversePayment: 'Reverse incorrect registration',
        reverseHint: 'Record an actual refund as a new payment in the opposite direction. This reversal corrects an incorrect registration with a documented reason.',
        reason: 'Reason',
        history: 'Change history',
        ALLOCATION: 'Invoice settlement',
        ALLOCATION_REVERSAL: 'Settlement reversed',
        previous: 'Previous',
        next: 'Next',
        title: 'Payments',
        subtitle: 'Actual receipts and disbursements with invoice allocations.',
        new: 'Record payment',
        save: 'Save executed payment',
        party: 'Partner account',
        CUSTOMER: 'Customer',
        VENDOR: 'Supplier',
        partner: 'Customer / supplier',
        direction: 'Payment direction',
        CREDIT: 'Receipt',
        DEBIT: 'Disbursement',
        amount: 'Payment amount',
        bookingDate: 'Payment date',
        valueDate: 'Value date',
        account: 'Money account',
        currency: 'Currency',
        reference: 'Purpose / source evidence',
        fee: 'Fees in payment currency',
        advanced: 'More details',
        rate: 'Rate to ledger currency',
        rateSource: 'Rate source',
        rateDate: 'Rate date',
        allocations: 'Allocate invoices',
        selectInvoice: 'Select invoice {{number}}',
        invoiceAmount: 'Payment in invoice currency',
        moneyAmount: 'Settlement in payment currency',
        discount: 'Discount in invoice currency',
        effectiveDate: 'Allocation effective on',
        noOpen: 'No open invoices for this selection.',
        unallocatedHint: 'Without an invoice allocation, the payment remains partner credit or an unresolved amount.',
        actualHint: 'Record payments already executed. Recording does not send a payment order to a bank.',
        saved: 'Payment recorded.',
        status: 'Status',
        ACTIVE: 'Recorded',
        REVERSED: 'Corrected',
        all: 'All',
        source: 'Source',
        MANUAL: 'Manual',
        BANK_IMPORT: 'Bank import',
        remaining: 'Unallocated',
        details: 'Payment details',
        journal: 'Journal entry',
        bankEvidence: 'Bank evidence',
        invoice: 'Invoice',
        allocated: 'Allocated',
        paymentTotal: 'Settlement amount including fees',
        setupRequired: 'Set the accounting start and money accounts first.',
        partnersEmpty: 'No matching customer or supplier.',
        search: 'Search payments',
        recorded: 'Recorded on',
        partnerCredit: 'Partner credit',
        invoiceCurrency: 'Invoice currency',
        addAllocation: 'Add invoice',
        removeAllocation: 'Remove allocation',
        referenceHint: 'For example, a bank statement, cash receipt or verifiable payment reference.',
        allocationHint: 'Split collective payments across invoices. For different currencies, explicitly enter both amounts and the rate source.',
        empty: 'No payments for this selection.',
        openItems: 'Open customer and supplier items',
        asOf: 'As of',
        dueDate: 'Due date',
        gross: 'Original amount',
        open: 'Open amount',
        OPEN: 'Open',
        OVERDUE: 'Overdue',
        CREDIT_BALANCE: 'Credit',
        SETTLED: 'Settled',
        homeOpen: 'Open in ledger currency',
        historyHint: 'Invoice recognition, payments and corrections take effect on their business dates. Later payments do not change earlier reporting dates.',
        unassigned: 'Without invoice',
        bankPostings: 'Bank postings',
    },
    tr: {
        advanceReassign: 'Avans eşleştirmesini düzelt',
        advanceReassignHint: 'Asıl eşleştirmenin tamamını aynı iş ortağı ve para birimine ait başka bir avans talebine taşıyın. Gerçek para değişmez. Önce mahsup edilmiş veya iade edilmiş payları çözün.',
        advanceReassignReady: 'Asıl eşleştirme ve incelenen yeni eşleştirme birlikte düzeltilecektir. Ek ödeme oluşturulmaz.',
        advanceReassignConfirm: 'Yeniden eşleştirmeyi onayla',
        advanceReassignSaved: 'Avans eşleştirmesi düzeltildi.',
        importAdvanceOriginalNotes: 'Orijinal avans notları',
        importAdvanceNotesHint: 'Bu metinler tedarikçinin orijinalinden değiştirilmeden alınmıştır. Aşağıdaki yorum ayrı bir insan kararıdır.',
        importAdvanceNotesReview: 'Orijinal notları incele',
        importAdvanceNotesDisposition: 'Orijinal notların yorumu',
        importAdvanceNotesChoose: 'Açıkça bir yorum seçin',
        importAdvanceNotesNoSpecific: 'Metinde belirlenebilir somut avans kesintisi yok',
        importAdvanceNotesMatchedChoices: 'Orijinal metin seçilen gerçek ödemelerle birebir karşılaştırıldı',
        importAdvanceNotesExplanation: 'Not incelemesinin gerekçesi',
        importAdvanceNotesManual: 'Orijinal notlar elle incelendi',
        importAdvanceNotesInvalid: 'Bir yorum seçin ve incelemeyi 10 ile 1000 karakter arasında açıklayın.',
        importAdvanceNotesUnavailable: 'Orijinal notlar şu anda güvenilir biçimde incelenemiyor. Güncel bilgileri yeniden yükleyin.',
        ADVANCE_REFUND: 'Avans iadesi eşleştirildi',
        ADVANCE_REFUND_REVERSAL: 'İade eşleştirmesi düzeltildi',
        advanceRefundCorrection: 'İade eşleştirmesini düzelt',
        advanceRefundCorrectionHint: 'Gerçek karşı ödeme kayıtlı kalır. Yalnızca bu eşleştirme ve vergi etkisi geri alınır; diğer eşleştirmeler korunur.',
        advanceRefundOriginal: 'Özgün iade',
        advanceRefundCorrectionConfirm: 'Eşleştirme düzeltmesini onayla',
        advanceRefundCorrectionSaved: 'İade eşleştirmesi düzeltildi.',
        advanceRefundCorrectionChanged: 'Ödeme bilgileri değişti. Güncel bilgileri inceleyip tekrar onaylayın. Girişleriniz korunur.',
        advanceRefundCorrectionRecheck: 'Güncel bilgileri yeniden incele',
        advanceRefund: 'Gerçek avans iadesini incele',
        advanceRefundHint: 'Başlangıçta ödenmiş avansı ve ters yönde kaydedilmiş iadeyi seçin. Onaylamadan önce kesin vergi tutarlarını inceleyin. Yeni ödeme oluşturulmaz.',
        advanceRefundSource: 'Başlangıçta ödenmiş avans talebi',
        advanceRefundCounterpayment: 'Gerçek karşı ödeme',
        advanceRefundNoSources: 'Bu ödeme için iade edilebilir ödenmiş avans bulunamadı.',
        advanceRefundNoCounterpayment: 'Uygun ve eşleştirilmemiş karşı ödeme yok. Önce gerçek iadeyi kaydedin, ardından bu incelemeye dönün.',
        advanceRefundRecord: 'Gerçek iadeyi kaydet',
        advanceRefundAvailable: 'İade edilebilir brüt',
        advanceRefundReview: 'İadeyi incele',
        advanceRefundConfirm: 'İncelenen iadeyi onayla',
        advanceRefundSaved: 'Avans iadesi kaydedildi.',
        advanceRefundMore: 'Diğer özgün avansları göster',
        advanceRefundChanged: 'Avans veya ödemeler değişti. Güncel kaynak bilgilerini ve iadeyi yeniden inceleyin; girdileriniz korunur.',
        advanceRefundChoice: 'Özgün avansı seç',
        advanceRefundCounterChoice: 'Karşı ödemeyi seç',
        advanceRefundPaymentFacts: '{{date}} · {{reference}} · {{amount}}',
        advanceRefundSourceFacts: '{{number}} · Ödeme tarihi {{date}}',
        importAdvanceOriginalDeductions: 'Orijinaldeki avans indirimleri',
        importAdvanceDeductionRequired: 'Orijinalde listelenen avanslar seçilen ödemelerle karşılaştırılmalıdır.',
        importAdvanceDeductionMatched: 'Seçilen avanslar orijinaldeki indirimlerle eşleşiyor.',
        importAdvanceDeductionConflict: 'Orijinaldeki avans indirimleri ödeme kanıtlarıyla eşleşmiyor. Belge numaralarını, tarihleri ve tutarları kontrol edin.',
        importAdvanceTitle: 'İçe aktarılan son faturanın avansları',
        importAdvanceHint: 'Tedarikçinin önceden ödenmiş tutarını belirli gerçek ödemeler ve vergi gruplarıyla eşleştirin. Orijinal fatura değişmez ve yeni bir ödeme oluşturulmaz.',
        importAdvanceOriginal: 'Orijinal brüt toplam',
        importAdvancePrepaid: 'Orijinal avans tutarı',
        importAdvanceDue: 'Orijinal kalan tutar',
        importAdvanceReceipt: '{{number}} · Ödeme tarihi {{date}}',
        importAdvanceAvailable: 'Kullanılabilir brüt tutar',
        importAdvanceEmpty: 'Eşleşen ödenmiş avans bulunamadı.',
        importAdvanceChanged: 'Fatura veya avansları değişti. Güncel bilgileri yeniden yükleyip eşleştirmeyi tekrar inceleyin.',
        importAdvanceSaved: 'İncelenen avans eşleştirmesi kaydedildi.',
        importAdvanceConfirmed: 'Kaydedilmiş avans eşleştirmesi',
        importAdvanceReadOnly: 'Bu eşleştirmeyi değiştirmek için ödeme ve satın alma düzenleme izinleri gerekir.',
        importAdvanceMore: 'Diğer ödenmiş avansları göster',
        advanceCancelled: 'Avans talebi iptal edildi',
        advanceRequested: 'Talep edilen tutar',
        advanceReviewed: 'İptal sırasında incelenen durum',
        advanceCurrent: 'Güncel durum',
        advanceDispositionChanged: 'Fonların kullanımı iptalden sonra değişti.',
        advanceDispositionUnchanged: 'Fonların kullanımı iptalden sonra değişmedi.',
        advanceCancelState: 'Avans talebinin iptali',
        advanceCancel: 'Avans talebini iptal et',
        advanceCancelDate: 'Geçerlilik tarihi',
        advanceCancelReason: 'İptal gerekçesi',
        advanceCancelReview: 'İptali gözden geçir',
        advanceCancelSubmit: 'Talebi iptal et',
        advanceRetained: 'Kalan avans',
        advanceCancelChanged: 'İlgili ödemeler değişti. Yeniden gözden geçirin.',
        advanceCancelHelp: 'Alınmış veya ödenmiş tutarlar, gerçek iade ya da izin verilen yeniden eşleştirmeye kadar korunur.',
        advanceDeductible: 'İndirilebilir KDV',
        advanceChoices: 'Avansları eşleştir',
        advanceChoiceHint: 'Bir avans talebi seçin ve her vergi oranı için tutarı gözden geçirin.',
        advanceCurrency: 'Avans talebinin para birimi',
        advanceMoneyHint: 'Belge tutarı, gerçek ödeme payı ve yasal KDV kuru ayrı ayrı incelenir.',
        advanceRefundActualMoney: 'Gerçekte iade edilen tutar ({{currency}})',
        advanceChooseRate: 'Yasal vergi kurunu seçin',
        noAdvances: 'Açık avans talebi bulunamadı.',
        firstPage: 'İlk sayfa',
        advanceRateAmount: '%{{rate}} oranındaki tutar',
        advanceReason: 'Eşleştirme gerekçesi',
        advanceSelected: 'Seçilen tutar',
        advanceReview: 'Eşleştirmeyi gözden geçir',
        advanceGross: 'Brüt',
        advanceTax: 'KDV',
        advanceAdd: 'Kontrol edilen eşleştirmeyi ekle',
        WRITE_OFF_RECOVERY: 'Gider yazılan alacak yeniden oluşturuldu',
        WRITE_OFF_RECOVERY_REVERSAL: 'Alacak geri oluşturma işlemi düzeltildi',
        WRITE_OFF_CREDIT_CORRECTION: 'Alacak zararı fatura düzeltmesiyle mahsup edildi',
        CREDIT_DISCOUNT_CORRECTION: 'İskonto fatura düzeltmesiyle mahsup edildi',
        offsetReview: 'Seçimi yeniden denetle',
        offsetReviewed: 'Bakiyeler ve sürümler güncellendi. Kaydetmeden önce tutarları ve tarihi kontrol edin.',
        offset: 'Bakiyeyi mahsup et',
        offsetCounterpart: 'Aynı tarafın ters yönlü ödemesi',
        offsetAmount: 'Bu ödemenin tutarı',
        offsetOtherAmount: 'Karşı ödemenin tutarı',
        offsetSave: 'Mahsubu kaydet',
        offsetHint: 'Önceden kaydedilmiş para giriş ve çıkışlarını bağlar. Yeni ödeme oluşmaz. Farklı para birimlerinde iki tutarı ve dönüşüm kaynağını açıkça kontrol edin.',
        offsetEmpty: 'Kullanılabilir bakiyesi olan uygun ödeme bulunamadı.',
        reverseOffset: 'Mahsubu iptal et',
        offsetReverseHint: 'Yalnızca mahsup işlemini iptal eder. Gerçek ödemeler ve ilk kanıtları korunur.',
        offsetDefaultReason: 'İade mevcut taraf bakiyesiyle mahsup edildi',
        PAYMENT_OFFSET: 'Bakiye mahsubu',
        PAYMENT_OFFSET_REVERSAL: 'Bakiye mahsubu iptal edildi',
        baseCurrencyRate: 'Temel para birimi',
        selectAccount: 'Para hesabı seç',
        saveAllocation: 'Eşleştirmeyi kaydet',
        allocationSaved: 'Eşleştirme kaydedildi.',
        reverseAllocation: 'Eşleştirmeyi geri al',
        reversePayment: 'Yanlış kaydı ters çevir',
        reverseHint: 'Gerçek bir iadeyi ters yönde yeni ödeme olarak kaydedin. Bu ters kayıt, yanlış kaydı belgelenmiş gerekçeyle düzeltir.',
        reason: 'Gerekçe',
        history: 'Değişiklik geçmişi',
        ALLOCATION: 'Fatura kapama',
        ALLOCATION_REVERSAL: 'Kapama geri alındı',
        previous: 'Önceki',
        next: 'Sonraki',
        title: 'Ödemeler',
        subtitle: 'Fatura eşleştirmeleriyle gerçekleşmiş para giriş ve çıkışları.',
        new: 'Ödeme kaydet',
        save: 'Gerçekleşen ödemeyi kaydet',
        party: 'Cari hesap',
        CUSTOMER: 'Müşteri',
        VENDOR: 'Tedarikçi',
        partner: 'Müşteri / tedarikçi',
        direction: 'Ödeme yönü',
        CREDIT: 'Para girişi',
        DEBIT: 'Para çıkışı',
        amount: 'Ödeme tutarı',
        bookingDate: 'Ödeme tarihi',
        valueDate: 'Valör tarihi',
        account: 'Para hesabı',
        currency: 'Para birimi',
        reference: 'Açıklama / kaynak belgesi',
        fee: 'Ödeme para biriminde masraf',
        advanced: 'Diğer bilgiler',
        rate: 'Muhasebe para birimine kur',
        rateSource: 'Kur kaynağı',
        rateDate: 'Kur tarihi',
        allocations: 'Faturaları eşleştir',
        selectInvoice: '{{number}} faturasını seç',
        invoiceAmount: 'Fatura para biriminde ödeme',
        moneyAmount: 'Ödeme para biriminde kapama',
        discount: 'Fatura para biriminde iskonto',
        effectiveDate: 'Eşleştirme geçerlilik tarihi',
        noOpen: 'Bu seçim için açık fatura yok.',
        unallocatedHint: 'Fatura eşleştirilmezse ödeme, cari hesap bakiyesi veya açıklanmamış tutar olarak kalır.',
        actualHint: 'Buraya gerçekleşmiş ödemeleri kaydedin. Kayıt, bankaya ödeme talimatı göndermez.',
        saved: 'Ödeme kaydedildi.',
        status: 'Durum',
        ACTIVE: 'Kaydedildi',
        REVERSED: 'Düzeltildi',
        all: 'Tümü',
        source: 'Kaynak',
        MANUAL: 'Manuel',
        BANK_IMPORT: 'Banka içe aktarımı',
        remaining: 'Eşleştirilmemiş',
        details: 'Ödeme ayrıntıları',
        journal: 'Muhasebe kaydı',
        bankEvidence: 'Banka belgesi',
        invoice: 'Fatura',
        allocated: 'Eşleştirilen',
        paymentTotal: 'Masraflar dahil kapama tutarı',
        setupRequired: 'Önce muhasebe başlangıcını ve para hesaplarını ayarlayın.',
        partnersEmpty: 'Uygun müşteri veya tedarikçi yok.',
        search: 'Ödemelerde ara',
        recorded: 'Kayıt tarihi',
        partnerCredit: 'Cari hesap bakiyesi',
        invoiceCurrency: 'Fatura para birimi',
        addAllocation: 'Fatura ekle',
        removeAllocation: 'Eşleştirmeyi kaldır',
        referenceHint: 'Örneğin hesap özeti, kasa fişi veya doğrulanabilir ödeme referansı.',
        allocationHint: 'Toplu ödemeyi birden fazla faturaya dağıtın. Farklı para birimlerinde iki tutarı ve kur kaynağını açıkça girin.',
        empty: 'Bu seçim için ödeme yok.',
        openItems: 'Açık müşteri ve tedarikçi kalemleri',
        asOf: 'Rapor tarihi',
        dueDate: 'Vade',
        gross: 'Asıl tutar',
        open: 'Açık tutar',
        OPEN: 'Açık',
        OVERDUE: 'Vadesi geçmiş',
        CREDIT_BALANCE: 'Bakiye',
        SETTLED: 'Kapatıldı',
        homeOpen: 'Muhasebe para biriminde açık tutar',
        historyHint: 'Fatura kayıtları, ödemeler ve düzeltmeler kendi işlem tarihlerinde etkili olur. Sonraki ödemeler geçmiş rapor tarihlerini değiştirmez.',
        unassigned: 'Faturasız',
        bankPostings: 'Banka kayıtları',
    },
    fr: {
        advanceReassign: 'Corriger l’affectation de l’acompte',
        advanceReassignHint: 'Transférez toute l’affectation d’origine vers une autre demande d’acompte du même partenaire et dans la même devise. La trésorerie réelle reste inchangée. Traitez d’abord les parts déjà imputées ou remboursées.',
        advanceReassignReady: 'L’affectation d’origine et son remplacement vérifié seront corrigés ensemble. Aucun paiement supplémentaire n’est créé.',
        advanceReassignConfirm: 'Confirmer la réaffectation',
        advanceReassignSaved: 'L’affectation de l’acompte a été corrigée.',
        importAdvanceOriginalNotes: 'Notes originales sur les acomptes',
        importAdvanceNotesHint: 'Ces textes proviennent sans modification de l’original du fournisseur. L’interprétation ci-dessous est une décision humaine distincte.',
        importAdvanceNotesReview: 'Vérifier les notes originales',
        importAdvanceNotesDisposition: 'Interprétation des notes originales',
        importAdvanceNotesChoose: 'Choisir explicitement une interprétation',
        importAdvanceNotesNoSpecific: 'Aucune déduction précise d’acompte identifiable dans le texte',
        importAdvanceNotesMatchedChoices: 'Texte original comparé aux paiements réels précisément sélectionnés',
        importAdvanceNotesExplanation: 'Explication de la vérification des notes',
        importAdvanceNotesManual: 'Notes originales vérifiées manuellement',
        importAdvanceNotesInvalid: 'Choisissez une interprétation et expliquez la vérification en 10 à 1000 caractères.',
        importAdvanceNotesUnavailable: 'Les notes originales ne peuvent pas être vérifiées de manière fiable actuellement. Rechargez les informations actuelles.',
        ADVANCE_REFUND: 'Remboursement d’acompte affecté',
        ADVANCE_REFUND_REVERSAL: 'Affectation du remboursement corrigée',
        advanceRefundCorrection: 'Corriger l’affectation du remboursement',
        advanceRefundCorrectionHint: 'Le paiement opposé réel reste enregistré. Seules cette affectation et son incidence fiscale sont annulées ; les autres affectations sont conservées.',
        advanceRefundOriginal: 'Remboursement initial',
        advanceRefundCorrectionConfirm: 'Confirmer la correction de l’affectation',
        advanceRefundCorrectionSaved: 'L’affectation du remboursement a été corrigée.',
        advanceRefundCorrectionChanged: 'Les données du paiement ont changé. Vérifiez les données actuelles et confirmez à nouveau. Vos saisies sont conservées.',
        advanceRefundCorrectionRecheck: 'Revérifier les données actuelles',
        advanceRefund: 'Vérifier le remboursement réel d’un acompte',
        advanceRefundHint: 'Sélectionnez l’acompte initialement payé et un remboursement enregistré en sens inverse. Vérifiez les montants fiscaux exacts avant confirmation. Aucun paiement n’est créé.',
        advanceRefundSource: 'Demande d’acompte initialement payée',
        advanceRefundCounterpayment: 'Paiement opposé réel',
        advanceRefundNoSources: 'Aucun acompte payé remboursable n’a été trouvé pour ce paiement.',
        advanceRefundNoCounterpayment: 'Aucun paiement opposé disponible ne correspond. Enregistrez d’abord le remboursement réel, puis revenez à cette vérification.',
        advanceRefundRecord: 'Enregistrer le remboursement réel',
        advanceRefundAvailable: 'Montant TTC remboursable',
        advanceRefundReview: 'Vérifier le remboursement',
        advanceRefundConfirm: 'Confirmer le remboursement vérifié',
        advanceRefundSaved: 'Le remboursement d’acompte a été enregistré.',
        advanceRefundMore: 'Afficher d’autres acomptes initiaux',
        advanceRefundChanged: 'L’acompte ou les paiements ont changé. Vérifiez de nouveau les données sources actuelles et le remboursement ; vos saisies sont conservées.',
        advanceRefundChoice: 'Sélectionner l’acompte initial',
        advanceRefundCounterChoice: 'Sélectionner le paiement opposé',
        advanceRefundPaymentFacts: '{{date}} · {{reference}} · {{amount}}',
        advanceRefundSourceFacts: '{{number}} · Payé le {{date}}',
        importAdvanceOriginalDeductions: 'Déductions d’acomptes de l’original',
        importAdvanceDeductionRequired: 'Les acomptes indiqués dans l’original doivent être rapprochés des paiements sélectionnés.',
        importAdvanceDeductionMatched: 'Les acomptes sélectionnés correspondent aux déductions de l’original.',
        importAdvanceDeductionConflict: 'Les déductions d’acomptes de l’original ne correspondent pas aux justificatifs de paiement. Vérifiez les numéros de document, dates et montants.',
        importAdvanceTitle: 'Acomptes de la facture finale importée',
        importAdvanceHint: 'Rapprochez le montant déjà payé indiqué par le fournisseur avec des paiements réels et des groupes de taxe précis. La facture originale reste inchangée et aucun nouveau paiement n’est créé.',
        importAdvanceOriginal: 'Total brut original',
        importAdvancePrepaid: 'Acomptes selon l’original',
        importAdvanceDue: 'Solde selon l’original',
        importAdvanceReceipt: '{{number}} · Paiement du {{date}}',
        importAdvanceAvailable: 'Montant brut disponible',
        importAdvanceEmpty: 'Aucun acompte payé correspondant n’est disponible.',
        importAdvanceChanged: 'La facture ou ses acomptes ont changé. Rechargez les données et vérifiez à nouveau l’affectation.',
        importAdvanceSaved: 'L’affectation vérifiée des acomptes a été enregistrée.',
        importAdvanceConfirmed: 'Affectation enregistrée des acomptes',
        importAdvanceReadOnly: 'Les droits de modification des paiements et des achats sont requis pour modifier cette affectation.',
        importAdvanceMore: 'Afficher d’autres acomptes payés',
        advanceCancelled: 'Demande d’acompte annulée',
        advanceRequested: 'Montant demandé',
        advanceReviewed: 'Vérifié lors de l’annulation',
        advanceCurrent: 'Situation actuelle',
        advanceDispositionChanged: 'L’utilisation des fonds a changé depuis l’annulation.',
        advanceDispositionUnchanged: 'L’utilisation des fonds est inchangée depuis l’annulation.',
        advanceCancelState: 'Annulation de la demande d’acompte',
        advanceCancel: 'Annuler la demande d’acompte',
        advanceCancelDate: 'Date d’effet',
        advanceCancelReason: 'Motif de l’annulation',
        advanceCancelReview: 'Vérifier l’annulation',
        advanceCancelSubmit: 'Annuler la demande',
        advanceRetained: 'Acompte conservé',
        advanceCancelChanged: 'Les paiements ont changé. Vérifiez à nouveau.',
        advanceCancelHelp: 'Les montants reçus ou versés restent comptabilisés jusqu’au remboursement réel ou à une réaffectation autorisée.',
        advanceDeductible: 'TVA déductible',
        advanceChoices: 'Affecter les acomptes',
        advanceChoiceHint: 'Choisissez une demande d’acompte et vérifiez le montant par taux de TVA.',
        advanceCurrency: 'Devise de la demande d’acompte',
        advanceMoneyHint: 'Le montant du document, la part du paiement réel et le taux légal de TVA sont vérifiés séparément.',
        advanceRefundActualMoney: 'Montant réellement remboursé ({{currency}})',
        advanceChooseRate: 'Choisir le taux légal',
        noAdvances: 'Aucune demande d’acompte ouverte.',
        firstPage: 'Première page',
        advanceRateAmount: 'Montant au taux de {{rate}} %',
        advanceReason: 'Motif de l’affectation',
        advanceSelected: 'Montant sélectionné',
        advanceReview: 'Vérifier l’affectation',
        advanceGross: 'Brut',
        advanceTax: 'TVA',
        advanceAdd: 'Ajouter l’affectation vérifiée',
        WRITE_OFF_RECOVERY: 'Créance passée en perte rétablie',
        WRITE_OFF_RECOVERY_REVERSAL: 'Rétablissement de créance corrigé',
        WRITE_OFF_CREDIT_CORRECTION: 'Perte sur créance compensée par une correction de facture',
        CREDIT_DISCOUNT_CORRECTION: 'Escompte compensé par une correction de facture',
        offsetReview: 'Revérifier la sélection',
        offsetReviewed: 'Soldes et versions actualisés. Vérifiez les montants et la date avant l’enregistrement.',
        offset: 'Compenser un crédit',
        offsetCounterpart: 'Paiement inverse du même partenaire',
        offsetAmount: 'Montant de ce paiement',
        offsetOtherAmount: 'Montant de contrepartie',
        offsetSave: 'Enregistrer la compensation',
        offsetHint: 'Lie des entrées et sorties déjà enregistrées. Aucun paiement supplémentaire n’est créé. Pour des devises différentes, vérifiez explicitement les deux montants et la source de conversion.',
        offsetEmpty: 'Aucun paiement correspondant avec solde disponible.',
        reverseOffset: 'Annuler la compensation',
        offsetReverseHint: 'Annule uniquement la compensation. Les paiements réels et leurs justificatifs d’origine restent conservés.',
        offsetDefaultReason: 'Remboursement compensé avec le crédit existant du partenaire',
        PAYMENT_OFFSET: 'Compensation de crédit',
        PAYMENT_OFFSET_REVERSAL: 'Compensation de crédit annulée',
        baseCurrencyRate: 'Devise de base',
        selectAccount: 'Choisir un compte de trésorerie',
        saveAllocation: 'Enregistrer l’affectation',
        allocationSaved: 'Affectation enregistrée.',
        reverseAllocation: 'Annuler l’affectation',
        reversePayment: 'Contrepasser une saisie incorrecte',
        reverseHint: 'Saisissez un remboursement réel comme nouveau paiement de sens opposé. Cette contrepassation corrige une saisie incorrecte avec un motif documenté.',
        reason: 'Motif',
        history: 'Historique des modifications',
        ALLOCATION: 'Règlement de facture',
        ALLOCATION_REVERSAL: 'Règlement contrepassé',
        previous: 'Précédent',
        next: 'Suivant',
        title: 'Paiements',
        subtitle: 'Encaissements et décaissements effectués et affectations aux factures.',
        new: 'Saisir un paiement',
        save: 'Enregistrer le paiement effectué',
        party: 'Compte du partenaire',
        CUSTOMER: 'Client',
        VENDOR: 'Fournisseur',
        partner: 'Client / fournisseur',
        direction: 'Sens du paiement',
        CREDIT: 'Encaissement',
        DEBIT: 'Décaissement',
        amount: 'Montant du paiement',
        bookingDate: 'Date du paiement',
        valueDate: 'Date de valeur',
        account: 'Compte de trésorerie',
        currency: 'Devise',
        reference: 'Motif / justificatif d’origine',
        fee: 'Frais dans la devise du paiement',
        advanced: 'Autres informations',
        rate: 'Taux vers la devise comptable',
        rateSource: 'Source du taux',
        rateDate: 'Date du taux',
        allocations: 'Affecter les factures',
        selectInvoice: 'Sélectionner la facture {{number}}',
        invoiceAmount: 'Paiement en devise de facture',
        moneyAmount: 'Règlement en devise du paiement',
        discount: 'Escompte en devise de facture',
        effectiveDate: 'Date d’effet de l’affectation',
        noOpen: 'Aucune facture ouverte pour cette sélection.',
        unallocatedHint: 'Sans affectation, le paiement reste un crédit partenaire ou un montant à clarifier.',
        actualHint: 'Saisissez les paiements déjà effectués. La saisie n’envoie aucun ordre de paiement bancaire.',
        saved: 'Paiement enregistré.',
        status: 'Statut',
        ACTIVE: 'Enregistré',
        REVERSED: 'Corrigé',
        all: 'Tous',
        source: 'Origine',
        MANUAL: 'Manuelle',
        BANK_IMPORT: 'Import bancaire',
        remaining: 'Non affecté',
        details: 'Détails du paiement',
        journal: 'Écriture comptable',
        bankEvidence: 'Justificatif bancaire',
        invoice: 'Facture',
        allocated: 'Affecté',
        paymentTotal: 'Montant du règlement frais compris',
        setupRequired: 'Configurez d’abord le début comptable et les comptes de trésorerie.',
        partnersEmpty: 'Aucun client ou fournisseur correspondant.',
        search: 'Rechercher les paiements',
        recorded: 'Enregistré le',
        partnerCredit: 'Crédit partenaire',
        invoiceCurrency: 'Devise de facture',
        addAllocation: 'Ajouter une facture',
        removeAllocation: 'Retirer l’affectation',
        referenceHint: 'Par exemple un relevé bancaire, un reçu de caisse ou une référence vérifiable.',
        allocationHint: 'Répartissez les règlements groupés entre plusieurs factures. En devises différentes, indiquez explicitement les deux montants et la source du taux.',
        empty: 'Aucun paiement pour cette sélection.',
        openItems: 'Postes ouverts clients et fournisseurs',
        asOf: 'Date d’arrêté',
        dueDate: 'Échéance',
        gross: 'Montant initial',
        open: 'Montant ouvert',
        OPEN: 'Ouvert',
        OVERDUE: 'Échu',
        CREDIT_BALANCE: 'Crédit',
        SETTLED: 'Soldé',
        homeOpen: 'Ouvert en devise comptable',
        historyHint: 'Factures, paiements et corrections prennent effet à leurs dates métier. Les paiements ultérieurs ne modifient pas les arrêtés antérieurs.',
        unassigned: 'Sans facture',
        bankPostings: 'Écritures bancaires',
    },
    es: {
        advanceReassign: 'Corregir asignación del anticipo',
        advanceReassignHint: 'Traslade toda la asignación original a otra solicitud de anticipo del mismo socio y moneda. El dinero real no cambia. Resuelva antes las partes ya aplicadas o reembolsadas.',
        advanceReassignReady: 'La asignación original y su sustitución revisada se corregirán juntas. No se crea ningún pago adicional.',
        advanceReassignConfirm: 'Confirmar reasignación',
        advanceReassignSaved: 'Se corrigió la asignación del anticipo.',
        importAdvanceOriginalNotes: 'Notas originales sobre anticipos',
        importAdvanceNotesHint: 'Estos textos proceden sin cambios del original del proveedor. La interpretación siguiente es una decisión humana independiente.',
        importAdvanceNotesReview: 'Revisar las notas originales',
        importAdvanceNotesDisposition: 'Interpretación de las notas originales',
        importAdvanceNotesChoose: 'Elegir expresamente una interpretación',
        importAdvanceNotesNoSpecific: 'No se identifican deducciones específicas de anticipos en el texto',
        importAdvanceNotesMatchedChoices: 'Texto original comparado con los pagos reales seleccionados exactamente',
        importAdvanceNotesExplanation: 'Explicación de la revisión de notas',
        importAdvanceNotesManual: 'Notas originales revisadas manualmente',
        importAdvanceNotesInvalid: 'Elige una interpretación y explica la revisión con entre 10 y 1000 caracteres.',
        importAdvanceNotesUnavailable: 'Las notas originales no pueden revisarse de forma fiable en este momento. Recarga la información actual.',
        ADVANCE_REFUND: 'Reembolso de anticipo asignado',
        ADVANCE_REFUND_REVERSAL: 'Asignación del reembolso corregida',
        advanceRefundCorrection: 'Corregir asignación del reembolso',
        advanceRefundCorrectionHint: 'El pago real en sentido opuesto sigue registrado. Solo se revierten esta asignación y su efecto fiscal; las demás asignaciones se conservan.',
        advanceRefundOriginal: 'Reembolso original',
        advanceRefundCorrectionConfirm: 'Confirmar corrección de asignación',
        advanceRefundCorrectionSaved: 'Se corrigió la asignación del reembolso.',
        advanceRefundCorrectionChanged: 'Los datos del pago han cambiado. Revise los datos actuales y confirme de nuevo. Se conservan sus entradas.',
        advanceRefundCorrectionRecheck: 'Revisar de nuevo los datos actuales',
        advanceRefund: 'Revisar devolución real del anticipo',
        advanceRefundHint: 'Seleccione el anticipo pagado originalmente y una devolución registrada en sentido opuesto. Revise los importes fiscales exactos antes de confirmar. No se crea ningún pago.',
        advanceRefundSource: 'Solicitud de anticipo pagada originalmente',
        advanceRefundCounterpayment: 'Pago real en sentido opuesto',
        advanceRefundNoSources: 'No se encontró ningún anticipo pagado reembolsable para este pago.',
        advanceRefundNoCounterpayment: 'No hay un pago opuesto disponible que coincida. Registre primero la devolución real y vuelva después a esta revisión.',
        advanceRefundRecord: 'Registrar devolución real',
        advanceRefundAvailable: 'Bruto reembolsable',
        advanceRefundReview: 'Revisar devolución',
        advanceRefundConfirm: 'Confirmar devolución revisada',
        advanceRefundSaved: 'Se registró la devolución del anticipo.',
        advanceRefundMore: 'Mostrar más anticipos originales',
        advanceRefundChanged: 'El anticipo o los pagos han cambiado. Revise otra vez los datos originales actuales y la devolución; se conservan sus datos.',
        advanceRefundChoice: 'Seleccionar anticipo original',
        advanceRefundCounterChoice: 'Seleccionar pago opuesto',
        advanceRefundPaymentFacts: '{{date}} · {{reference}} · {{amount}}',
        advanceRefundSourceFacts: '{{number}} · Pagado el {{date}}',
        importAdvanceOriginalDeductions: 'Deducciones de anticipos del original',
        importAdvanceDeductionRequired: 'Los anticipos del original deben compararse con los pagos seleccionados.',
        importAdvanceDeductionMatched: 'Los anticipos seleccionados coinciden con las deducciones del original.',
        importAdvanceDeductionConflict: 'Las deducciones de anticipos del original no coinciden con los justificantes de pago. Revisa los números de documento, fechas e importes.',
        importAdvanceTitle: 'Anticipos de la factura final importada',
        importAdvanceHint: 'Asocia el importe anticipado del proveedor con pagos reales y grupos fiscales concretos. La factura original no cambia y no se crea un nuevo pago.',
        importAdvanceOriginal: 'Total bruto original',
        importAdvancePrepaid: 'Anticipos del original',
        importAdvanceDue: 'Saldo pendiente del original',
        importAdvanceReceipt: '{{number}} · Pago del {{date}}',
        importAdvanceAvailable: 'Importe bruto disponible',
        importAdvanceEmpty: 'No hay ningún anticipo pagado que coincida.',
        importAdvanceChanged: 'La factura o sus anticipos han cambiado. Recarga los datos y vuelve a revisar la asignación.',
        importAdvanceSaved: 'Se ha guardado la asignación revisada de anticipos.',
        importAdvanceConfirmed: 'Asignación de anticipos guardada',
        importAdvanceReadOnly: 'Se requieren permisos para editar pagos y compras para cambiar esta asignación.',
        importAdvanceMore: 'Mostrar más anticipos pagados',
        advanceCancelled: 'Solicitud de anticipo cancelada',
        advanceRequested: 'Importe solicitado',
        advanceReviewed: 'Revisado al cancelar',
        advanceCurrent: 'Situación actual',
        advanceDispositionChanged: 'El destino de los fondos ha cambiado desde la cancelación.',
        advanceDispositionUnchanged: 'El destino de los fondos no ha cambiado desde la cancelación.',
        advanceCancelState: 'Cancelación de la solicitud de anticipo',
        advanceCancel: 'Cancelar solicitud de anticipo',
        advanceCancelDate: 'Fecha de efecto',
        advanceCancelReason: 'Motivo de cancelación',
        advanceCancelReview: 'Revisar cancelación',
        advanceCancelSubmit: 'Cancelar solicitud',
        advanceRetained: 'Anticipo retenido',
        advanceCancelChanged: 'Los pagos relacionados han cambiado. Vuelve a revisarlos.',
        advanceCancelHelp: 'Los importes recibidos o pagados se conservan hasta el reembolso real o una reasignación permitida.',
        advanceDeductible: 'IVA deducible',
        advanceChoices: 'Asignar anticipos',
        advanceChoiceHint: 'Elige una solicitud de anticipo y revisa el importe de cada tipo de IVA.',
        advanceCurrency: 'Moneda de la solicitud de anticipo',
        advanceMoneyHint: 'El importe del documento, la parte del pago real y el cambio fiscal del IVA se revisan por separado.',
        advanceRefundActualMoney: 'Importe realmente reembolsado ({{currency}})',
        advanceChooseRate: 'Elegir el cambio fiscal',
        noAdvances: 'No hay solicitudes de anticipo abiertas.',
        firstPage: 'Primera página',
        advanceRateAmount: 'Importe al {{rate}} %',
        advanceReason: 'Motivo de la asignación',
        advanceSelected: 'Importe seleccionado',
        advanceReview: 'Revisar asignación',
        advanceGross: 'Bruto',
        advanceTax: 'IVA',
        advanceAdd: 'Añadir asignación revisada',
        WRITE_OFF_RECOVERY: 'Crédito dado de baja restablecido',
        WRITE_OFF_RECOVERY_REVERSAL: 'Restablecimiento del crédito corregido',
        WRITE_OFF_CREDIT_CORRECTION: 'Pérdida del crédito compensada con rectificación de factura',
        CREDIT_DISCOUNT_CORRECTION: 'Descuento por pronto pago compensado con rectificación',
        offsetReview: 'Revisar selección',
        offsetReviewed: 'Saldos y versiones actualizados. Revise importes y fecha antes de guardar.',
        offset: 'Compensar saldo',
        offsetCounterpart: 'Pago contrario del mismo interlocutor',
        offsetAmount: 'Importe de este pago',
        offsetOtherAmount: 'Importe de contrapartida',
        offsetSave: 'Guardar compensación',
        offsetHint: 'Vincula entradas y salidas ya registradas. No se crea otro pago. En monedas diferentes, revise expresamente ambos importes y la fuente de conversión.',
        offsetEmpty: 'No hay pagos coincidentes con saldo disponible.',
        reverseOffset: 'Anular compensación',
        offsetReverseHint: 'Anula solo la compensación. Los pagos reales y sus justificantes originales se conservan.',
        offsetDefaultReason: 'Devolución compensada con el saldo existente del interlocutor',
        PAYMENT_OFFSET: 'Compensación de saldo',
        PAYMENT_OFFSET_REVERSAL: 'Compensación de saldo anulada',
        baseCurrencyRate: 'Moneda base',
        selectAccount: 'Seleccionar cuenta de tesorería',
        saveAllocation: 'Guardar asignación',
        allocationSaved: 'Asignación guardada.',
        reverseAllocation: 'Deshacer asignación',
        reversePayment: 'Revertir registro incorrecto',
        reverseHint: 'Registre un reembolso real como un nuevo pago en sentido contrario. Esta reversión corrige un registro incorrecto con un motivo documentado.',
        reason: 'Motivo',
        history: 'Historial de cambios',
        ALLOCATION: 'Liquidación de factura',
        ALLOCATION_REVERSAL: 'Liquidación revertida',
        previous: 'Anterior',
        next: 'Siguiente',
        title: 'Pagos',
        subtitle: 'Cobros y pagos efectuados con asignación a facturas.',
        new: 'Registrar pago',
        save: 'Guardar pago efectuado',
        party: 'Cuenta del tercero',
        CUSTOMER: 'Cliente',
        VENDOR: 'Proveedor',
        partner: 'Cliente / proveedor',
        direction: 'Dirección del pago',
        CREDIT: 'Cobro',
        DEBIT: 'Pago',
        amount: 'Importe del pago',
        bookingDate: 'Fecha del pago',
        valueDate: 'Fecha valor',
        account: 'Cuenta de tesorería',
        currency: 'Moneda',
        reference: 'Concepto / justificante de origen',
        fee: 'Comisiones en moneda del pago',
        advanced: 'Más datos',
        rate: 'Tipo a moneda contable',
        rateSource: 'Fuente del tipo',
        rateDate: 'Fecha del tipo',
        allocations: 'Asignar facturas',
        selectInvoice: 'Seleccionar factura {{number}}',
        invoiceAmount: 'Pago en moneda de factura',
        moneyAmount: 'Liquidación en moneda del pago',
        discount: 'Descuento en moneda de factura',
        effectiveDate: 'Fecha efectiva de asignación',
        noOpen: 'No hay facturas pendientes para esta selección.',
        unallocatedHint: 'Sin asignación, el pago permanece como saldo a favor del tercero o importe por aclarar.',
        actualHint: 'Registre pagos ya efectuados. El registro no envía órdenes de pago al banco.',
        saved: 'Pago registrado.',
        status: 'Estado',
        ACTIVE: 'Registrado',
        REVERSED: 'Corregido',
        all: 'Todos',
        source: 'Origen',
        MANUAL: 'Manual',
        BANK_IMPORT: 'Importación bancaria',
        remaining: 'Sin asignar',
        details: 'Detalles del pago',
        journal: 'Asiento contable',
        bankEvidence: 'Justificante bancario',
        invoice: 'Factura',
        allocated: 'Asignado',
        paymentTotal: 'Importe de liquidación con comisiones',
        setupRequired: 'Configure primero el inicio contable y las cuentas de tesorería.',
        partnersEmpty: 'No hay un cliente o proveedor coincidente.',
        search: 'Buscar pagos',
        recorded: 'Registrado el',
        partnerCredit: 'Saldo a favor del tercero',
        invoiceCurrency: 'Moneda de factura',
        addAllocation: 'Añadir factura',
        removeAllocation: 'Quitar asignación',
        referenceHint: 'Por ejemplo, extracto bancario, recibo de caja o referencia verificable.',
        allocationHint: 'Distribuya los pagos agrupados entre varias facturas. Con distintas monedas, introduzca ambos importes y la fuente del tipo expresamente.',
        empty: 'No hay pagos para esta selección.',
        openItems: 'Partidas abiertas de clientes y proveedores',
        asOf: 'Fecha de corte',
        dueDate: 'Vencimiento',
        gross: 'Importe original',
        open: 'Importe pendiente',
        OPEN: 'Pendiente',
        OVERDUE: 'Vencido',
        CREDIT_BALANCE: 'Saldo a favor',
        SETTLED: 'Compensado',
        homeOpen: 'Pendiente en moneda contable',
        historyHint: 'Facturas, pagos y correcciones surten efecto en sus fechas contables. Los pagos posteriores no modifican los cortes anteriores.',
        unassigned: 'Sin factura',
        bankPostings: 'Asientos bancarios',
    },
};
//# sourceMappingURL=ledger-payments.js.map